<template>
  <div class="payh5">
    <pg-header :navIndex="1"></pg-header>
    <div
      class="emptyData"
      v-if="gameList.length <= 0"
    >
      {{ $t("common.emptyData") }}
    </div>
    <ul v-if="gameList.length > 0">
      <li
        v-for="(item, index) in gameList"
        :key="index"
        @click="showDetail(item)"
      >
        <div class="gamelist-title">
          <img
            :src="item.game_image"
            alt=""
          />
          <!-- <img src="@/assets/images/h5/bilibg.png" alt="" /> -->
          <p>{{ item.game_name }}</p>
          <!-- <p>{{index}}</p> -->
        </div>
        <div class="gamelist-img">
          <img
            src="@/assets/images/h5/icon5.png"
            alt=""
          />
        </div>
      </li>
    </ul>
    <h5-nav v-if="$region !== 'jp' "></h5-nav>
  </div>
</template>
<script>
import h5Nav from "@/component/h5nav/komoe";
import pgHeader from "./component/pgHeader.vue";
import { mapGetters } from "vuex";
export default {
  name: "pays-h5",
  data() {
    return {
      gameList: [],
      distribution_region: 5,
      main_switch_status: "",
      secondary_switch_status: "",
      serverRoleList: [],
    };
  },
  components: {
    h5Nav,
    pgHeader,
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  created() {
    this.getSwitchStatus();
  },
  mounted() { },
  methods: {
    // 1.获取平台充值开关状态
    getSwitchStatus() {
      this.$apis.paygame.getKomoeSwitch().then(({ data }) => {
        if (data.code == 0) {
          this.main_switch_status = data.data.main_switch_status;
          this.secondary_switch_status = data.data.secondary_switch_status;

          // 支付总开关和游戏充值二级菜单开关状态是否开启
          if (
            this.main_switch_status === 1 &&
            this.secondary_switch_status === 1
          ) {
            // 2.获取支持网页支付游戏信息接口
            this.getGameList();
            // 判断是否登录
          } else {
            this.$router.push({ path: "/h5" });
          }
        } else {
          this.$router.push({ path: "/h5" });
        }
      });
    },
    showDetail(val) {
      // 判断是否登录
      const _that = this;
      this.$toast.loading({
        duration: 20000,
        message: _that.$t("h5page.footernav.text4"),
        overlay: true,
        forbidClick: true,
      });
      this.$apis.paygame
        .getKomoeRoleList(val.game_base_id)
        .then(({ data }) => {
          this.$toast.clear();
          if (data.code == 0) {
            // 获取区服、角色数据
            this.serverRoleList = data.data;
            // 对接口3数据做判断，如果用户没有任何角色信息，则不打开充值页面
            if (this.serverRoleList.length > 0) {
              // 没有角色和区服
              if (this.serverRoleList[0].cp_servers.length <= 0) {
                this.$notify({
                  message: _that.$t("paygame.msg9"),
                  color: "#fff",
                  background: "#50bbe5",
                });
                return;
              }
              this.$router.push({
                path: "/pays_h5/setoutpay",
                query: {
                  gameId: val.game_base_id,
                  gameName: val.game_name,
                  gameImg: val.game_image,
                },
              });
            } else {
              this.$notify({
                color: "#fff",
                background: "#50bbe5",
                message: _that.$t("paygame.err2"),
              });
            }
          } else if (data.code == -101) {
            this.goLogin(val.type)
          } else if (data.code == 2012) {
            // this.errMsgInfo = this.$t("paygame.msg10");
            this.$notify({
              color: "#fff",
              background: "#50bbe5",
              message: _that.$t("paygame.msg10"),
            });
          } else {
            this.$notify({
              color: "#fff",
              background: "#50bbe5",
              message: _that.$t("paygame.err2"),
            });
            // this.errMsgInfo = this.$t("paygame.err2");
          }
        })
        .catch(() => {
          this.$toast.clear();
        });
    },
    getGameList() {
      const _that = this;
      this.$toast.loading({
        duration: 20000,
        message: _that.$t("h5page.footernav.text4"),
        overlay: true,
        forbidClick: true,
      });
      this.$apis.paygame.getKomoeGameList().then(({ data }) => {
        this.$toast.clear();
        if (data.code == 0 && data.data.length) {
          this.gameList = data.data;
        }
      });
    },
    goLogin(gameType) {
      let url;
      if (gameType === 2) { // 新游戏
        url = `https://passport.komoejoy.com/login_h5/?type=both&redirect=${encodeURIComponent(location.href)}`;
      } else { // 老游戏
        url = `https://passport.komoejoy.com/login_h5/?redirect=${encodeURIComponent(location.href)}`;
      }
      window.location.href = url;
    }
  },
};
</script>
<style lang="scss" scoped>
$color_fonts: #444444;
$bg_color: #50bbe5;
.payh5 {
  width: 100%;
  margin-top: 1.04rem;
  min-height: calc(100vh - 2.75rem);
  height: auto;
  .emptyData {
    padding-top: 0.5rem;
    color: #b5b5b5;
    font-size: 0.16rem;
    text-align: center;
  }
  li {
    width: 92%;
    height: 0.55rem;
    margin: auto;
    margin-top: 0.15rem;
    background: #fbfbfb;
    &:nth-last-of-type(1) {
      margin-bottom: 0.1rem !important;
    }
    display: flex;
    align-items: center;
    justify-content: space-between;
    .gamelist-title {
      width: auto;
      height: 100%;
      margin-left: 0.05rem;
      display: flex;
      align-items: center;
      img {
        width: 0.44rem;
        height: 0.44rem;
        border-radius: 0.04rem;
        object-fit: cover;
      }
      p {
        margin-left: 0.13rem;
        font-size: 0.13rem;
        font-family: SourceHanSansCN;
        font-weight: bold;
        color: $color_fonts;
      }
    }
    .gamelist-img {
      width: 0.15rem;
      height: 0.15rem;
      margin-right: 0.05rem;
      background: $bg_color;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>
